export default __webpack_public_path__ + "static/media/formato120x120.a5c1e139.svg";